import { IApplicationState } from '../../types/redux';

export function getStaticMapUrl(state: IApplicationState) {
  return state.newbuilding.staticMapUrl;
}
